import Gikam from '../core/gikam-core.js';
import modal from './template/modal.vue';
import Mask from "./template/mask/mask";
import Vue from 'vue';
import Base from "./base";
import jQuery from 'jquery';

let defaultOptions = {
    id: void 0,
    title: void 0,
    width: void 0,
    height: void 0,
    src: void 0,
    showCloseBtn: true,
    toolbarTop: false,
    // 给modal-body 添加的样式
    bodyStyle:{},
};

export default class Modal extends Base {

    constructor(props) {
        super(props);
        this.listeners = {
            afterClose: Gikam.emptyFunction,
            beforeClose: Gikam.emptyFunction,
            resize: Gikam.emptyFunction
        };
        this.initialize(props, defaultOptions).init(props);
    }

    createModel() {
        let _this = this;
        this.options.modal = this;
        return new Vue({
            el: jQuery('<modal :options="options" ref="vm"></modal>').appendTo('body')[0],
            components: { modal },
            data() {
                return {
                    options: _this.options
                };
            }
        });
    }

    createWindow() {
        if (this.options.src) {
            return;
        }
        return Gikam.create('window', {
            renderTo: this.model.$el.querySelector('.modal-body'),
            toolbarTop: this.options.toolbarTop ? this.options.toolbarTop : this.options.url ? true : false,
            headerShow: false
        });
    }

    //开启遮罩
    openMask() {
        this.maskModel = new Vue({
            el: Gikam.createDom("div", this.model.$el.querySelector('.modal-body')),
            components: { Mask },
            render() {
                return <Mask />;
            }
        });
    }

    //关闭遮罩
    closeMask() {
        this.maskModel.$nextTick(() => {
            this.maskModel.$destroy();
            Gikam.removeDom(this.maskModel.$el);
            this.maskModel = null;
        });
    }

    //获取子组件Iframe元素对象
    getIframeDom () {
        return this.model.$children[0].getIframeDom();
    }

    load() {
        this.options.url && this.window.load(this.options.url);
    }

    close(data) {
        this.model.$children[0].close(data);
    }

    init() {
        this.model = this.createModel();
        this.window = this.createWindow();
        this.bindInstance(this.model.$el);
        this.load();
    }

}

